import * as React from "react";
import Pluralize from "components/common/Pluralize";
const SummarySubject = ({ request }) => {
  var _a;
  const selected = (_a = request.payload.selection) == null ? void 0 : _a.messages.length;
  const name = /* @__PURE__ */ React.createElement("strong", null, request.payload.name);
  if (selected === void 0) {
    return name;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, selected, " selected ", /* @__PURE__ */ React.createElement(Pluralize, { value: selected, singular: "message", plural: "messages" }), " of ", name);
};
export default SummarySubject;
